import React, { useState } from "react";
import { UseFormReturn } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { ButtonLoading, FormInput } from "go-form";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { OrganizationMeApi } from "../../../../services/Api/types";
import { api } from "../../../../services/Security/api";
import InvoiceDetailsAddressForm from "./InvoiceDetailsAddressForm";
import InvoiceDetailsContactForm from "./InvoiceDetailsContactForm";

interface Props {
	form: UseFormReturn<OrganizationMeApi>;
}

const InvoiceDetailsFormContent = ({ form }: Props) => {
	const { t } = useTranslation();
	const {
		register,
		formState: { errors },
		getValues,
		setValue,
		clearErrors,
		setError,
	} = form;
	const [searchingClient, setSearchingClient] = useState<boolean>(false);
	const { addFlash } = useFlash();

	const searchClient = async () => {
		try {
			const taxIdNo = getValues("tax_id_no");
			setSearchingClient(true);
			const res = await api.getClientDataByTaxIdNo(taxIdNo);
			const data = res.data.data;
			setValue("address.country", data.address_country);
			setValue("address.zip_code", data.address_zip_code);
			setValue("address.city", data.address_city);
			setValue("address.build_nr", data.address_build_nr);
			setValue("address.flat_nr", data.address_flat_nr);
			setValue("address.street", data.address_street);
			setValue("company_name", data.name);
			clearErrors("tax_id_no");
			clearErrors();
		} catch (err) {
			handleError.form(err, setError, addFlash);
		}
		setSearchingClient(false);
	};

	return (
		<fieldset className="form-group no-gutters">
			<div className={"row row-cols-md-2"}>
				<div className={"col-md-6"}>
					<FormInput
						label={t("lib:common.word.tax_id_no.title")}
						register={register}
						name="tax_id_no"
						errors={errors}
					/>
				</div>
				<div className={"col-md-6 d-flex align-items-end"}>
					<ButtonLoading
						loading={searchingClient}
						type="button"
						className="btn btn-add w-100 form-control"
						onClick={searchClient}
					>
						{t("lib:common.word.tax_id_no.search")}
					</ButtonLoading>
				</div>
			</div>
			<div className="w-100">
				<FormInput
					label={t("modules.settings.field.company_name.title")}
					register={register}
					name="company_name"
					errors={errors}
				/>
			</div>
			<InvoiceDetailsAddressForm form={form} />
			<InvoiceDetailsContactForm form={form} />
		</fieldset>
	);
};

export default InvoiceDetailsFormContent;
